/**
 * The stream's title belongs to the channel on ompeer.com. What the project holds is only a
 * draft: a title typed in this session that the channel does not have yet. It is sent once, and
 * dropped as soon as it went through, so a later go-live or edit never sends an old title over
 * one that was changed elsewhere since.
 */
export interface TitleDraft {
  /** The title typed in this session and not published yet; '' when there is none. */
  read(): string;
  clear(): void;
}

/** The title a go-live or a live edit sends: the draft, or none (the channel keeps the one it has). */
export const titleToSend = (draft: string): string | undefined => draft || undefined;

/**
 * Runs `publish` with the title to send and, once it went through, drops the draft it sent.
 * A publish that fails keeps the draft for the next attempt; one typed meanwhile is kept too.
 */
export async function publishTitleDraft<T>(draft: TitleDraft, publish: (title: string | undefined) => Promise<T>): Promise<T> {
  const title = titleToSend(draft.read());
  const result = await publish(title);
  if (title !== undefined && draft.read() === title) draft.clear();
  return result;
}
